Auth = require 'db/auth'
LocalStorageModel = require 'view-models/internal/local-storage-model'
_ = require 'underscore'

module.exports = new class extends LocalStorageModel

  constructor: ->
    super()
    @set({ id: "memberState-#{ Auth.myId() }" })
    @fetch()

  default: -> {
    cardsPageSortType: 'board'
    cardsPageFilter: 'active-month'
    cardsPageGroup: 'all'
    processingAttachmentsLength: 0
    idCollapsedChecklists: []
  }

  getCardsPageSortType: ->
    @get('cardsPageSortType')

  getCardsPageFilter: ->
    @get('cardsPageFilter')

  getCardsPageGroup: ->
    @get('cardsPageGroup')

  sortCardsPageByBoard: ->
    @save('cardsPageSortType', 'board')

  sortCardsPageByDate: ->
    @save('cardsPageSortType', 'date')

  setCardsPageFilter: (filter) ->
    @save('cardsPageFilter', filter)

  setCardsPageGroup: (group) ->
    @save('cardsPageGroup', group)

  getCollapsedChecklists: ->
    @get('idCollapsedChecklists')

  pullCollapsedChecklist: (idChecklist) ->
    @pull('idCollapsedChecklists', idChecklist)

  pushCollapsedChecklist: (idChecklist) ->
    @pull('idCollapsedChecklists', idChecklist)
    @addToSet('idCollapsedChecklists', idChecklist)
    collapsed = @getCollapsedChecklists()
    collapsedTrunc = _.rest(collapsed, Math.max(0, collapsed.length - 256))
    @save('idCollapsedChecklists', collapsedTrunc)



// WEBPACK FOOTER //
// ./app/scripts/view-models/member-state.coffee